<!--Fyve ActivationSummaryWrapper-->
<template>
  <div class="top-up-activation-summary summary-content">
    <slot name="txtBeforeTopUpActivationSummary"></slot>
    <Single :topUpInfo="singleTopUpData.amount" v-if="hasSingleTopUp" :change-btn="changeBtn">
      <template v-for="slot in possibleChildSlotsFor('Single')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Single>
    <Monthly :topUpInfo="topUpMonthly" v-if="topUpAutoMonthly" :change-btn="changeBtn">
      <template v-for="slot in possibleChildSlotsFor('Monthly')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Monthly>
    <ByLimit :topUpInfo="topUp" v-if="topUpAutoByLimit" :change-btn="changeBtn">
      <template v-for="slot in possibleChildSlotsFor('ByLimit')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ByLimit>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import slotProxy from '@/mixins/slotProxy'
import Monthly from '@/components/process/FYVE/Activation/Summary/Monthly.vue'
import ByLimit from '@/components/process/FYVE/Activation/Summary/ByLimit.vue'
import Single from '@/components/process/FYVE/Activation/Summary/Single.vue'

export default {
  name: 'TopUpSummaryWrapper',
  computed: {
    ...mapGetters('activation/topUp', [
      'topUp', 'singleTopUpData', 'hasSingleTopUp', 'topUpAutoMonthly', 'topUpAutoByLimit'
    ]),
    topUpMonthly: function () {
      return { amount: this.topUp.amount, trigger: '2' }
    }
  },
  props: {
    changeBtn: {
      default: true
    }
  },
  components: {
    Monthly,
    ByLimit,
    Single
  },
  mixins: [
    slotProxy()
  ]
}
</script>
